// SceneGenerateSection.jsx
// Import Libraries
import React, { useEffect, useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons';

// Import Context
import ScriptContext from '../../../context/Script.js';
import SessionContext from '../../../context/Session';
import ProjectViewContext from '../../../context/ProjectView';

// Import Services
import ScriptService from '../../../services/scriptService';

// Import Components
import Icon from '../../Elements/Icon';
import ProFlag from '../../../components/Elements/ProFlag.js';
import ProPill from '../../../components/Elements/ProPill.js';
import UpgradeMembership from '../../../components/Modals/Subscription/upgradeMembership.js';

// MUI
import { Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// Hooks
import useScenePermissions from '../../../hooks/useScenePermissions.js';

// Services
import analyticsService from '../../../services/analyticsService.js';

const SceneGenerateSection = ({ scene }) => {
  const { script, setScript } = useContext(ScriptContext);
  const { isMobile } = useContext(SessionContext);
  const { view, setView } = useContext(ProjectViewContext);

  const [floatDirection, setFloatDirection] = useState(isMobile ? 'left' : 'right');
  const [showMembershipModal, setShowMembershipModal] = useState(false);

  const { isSceneLocked, isGenerationLocked } = useScenePermissions(scene, script);

  const isManualScript = !script.path || script.path !== '';

  const closeMembershipModal = () => {
    setShowMembershipModal(false);
  };
  // -----------------------------------------------

  const generateShots = async (sceneNumber) => {
    const foundSceneIndex = script.scenes.findIndex((original) => original.id === sceneNumber);

    if (foundSceneIndex !== -1) {
      try {
        await ScriptService.getShotListForScene(script.id, script.scenes[foundSceneIndex].id);
      } catch (error) {
        console.error('Error generating shots:', error);
      }

      setView((prevView) => ({
        ...prevView,
        updateDictionary: {
          ...prevView.updateDictionary,
          subjects: true,
        },
      }));
    }
  };

  function changePdfView() {
    setView({ ...view, pdfActive: !view.pdfActive });
  }

  useEffect(() => {
    setFloatDirection(isMobile ? 'left' : 'right');
  }, [isMobile]);

  return (
    <>
      <UpgradeMembership
        isOpen={showMembershipModal}
        onRequestClose={closeMembershipModal}
        featureMsg=""
        scriptId={script?.id}
      />

      <span
        className={`${isMobile ? 'FullWidthFlex' : 'TenPortionFlex'}`}
        style={{ marginTop: isMobile ? '10px' : '0px' }}
      >
        {script && (scene?.ai_status <= 1 || !scene.shot_list || scene.shot_list?.length === 0) ? (
          <>
            {scene.isGeneratingShots === true || scene.ai_status === 1 ? (
              <img
                src="/Spinner-2.9s-297px.gif"
                className="loadingIcon icon"
                style={{ float: floatDirection, height: '40px', width: '40px' }}
                alt="Loading.."
              />
            ) : scene.scene_text && !isGenerationLocked && !isSceneLocked ? (
              <button
                className="buttonClone"
                style={{ marginLeft: isMobile ? '0px' : '7px', float: floatDirection }}
                onClick={() => generateShots(scene.id)}
              >
                Generate
              </button>
            ) : view.uploadedFile && (!scene.scene_text || scene.scene_text === '') ? (
              <span className="orangeText" style={{ float: floatDirection, paddingRight: '20px' }}>
                No Scene Text
              </span>
            ) : (
              <>
                <button
                  className="buttonClone"
                  style={{ float: floatDirection, marginLeft: '0px', marginRight: '0px' }}
                  disabled="disabled"
                >
                  Generate
                </button>

                {scene.scene_text && scene.scene_text !== '' ? (
                  <span
                    style={{
                      float: floatDirection,
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                  >
                    <ProFlag
                      type="pro"
                      featureMsg="Click here to upgrade, or continue to shotlist manually."
                      scriptLevel={script.features}
                      scriptId={script.id}
                      handleUpgrade={() =>
                        setScript((prev) => ({
                          ...prev,
                          features: 'Pro',
                        }))
                      }
                    />
                  </span>
                ) : null}
              </>
            )}
          </>
        ) : view.uploadedFile &&
          scene.page_start != null &&
          scene.page_end != null &&
          script.scenes[view.sceneIndex]?.id == scene.id &&
          (view.viewColumns == 2 || isMobile) ? (
          <button
            className={`buttonClone ${!isMobile ? 'TwoPortionFlex' : ''}`}
            onClick={() => changePdfView()}
            style={{ float: floatDirection, padding: '5px' }}
          >
            <Icon icon="Pdf" color="White" size={16} />

            <FontAwesomeIcon
              icon={view.pdfActive ? faCaretUp : faCaretDown}
              className="sizeUp SmallIcon"
              style={{ color: '#ffffff', marginTop: '5px', paddingRight: '5px' }}
            />
          </button>
        ) : script.scenes[view.sceneIndex]?.id !== scene.id && scene.shot_list ? (
          isSceneLocked ? (
            <span style={{ float: floatDirection, paddingRight: '20px' }}>
              <ProPill
                tooltip="View-only — upgrade to edit"
                onClick={(e) => {
                  e.stopPropagation();
                  analyticsService.trackEvent('locked_scene_edit_attempted');
                  analyticsService.trackEvent('upgrade_cta_clicked', { source: 'scene_lock' });
                  setShowMembershipModal(true);
                }}
              />
            </span>
          ) : (
            <Tooltip title="Ready" placement="top">
              <span style={{ float: floatDirection, paddingRight: '20px', display: 'inline-flex' }}>
                <CheckCircleIcon style={{ color: '#12AC7B' }} />
              </span>
            </Tooltip>
          )
        ) : null}
      </span>
    </>
  );
};

export default SceneGenerateSection;
